import React from "react";
import "../Account.css"
import { Link } from "react-router-dom";
import Img from "../../image/geo_acad.png"

const SignupFooter = () => {
    return (
        <footer className="account_footer">
                    <Link to="/"><img src={Img} alt="academi" className="logo"/></Link><p> © 2025 Geoinfotech  - Created By <a href="https://staff.geoinfotech.ng/" target="_blank" rel="noreferrer" style={{textDecoration: "none", color : "rgb(20, 115, 197)"}}>Geoinfotech Team</a></p>
                </footer>
    )
}
export default SignupFooter